import React from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import "./style.css";

const Description = ({ data, bg_color, richData }) => {
  const LinkRenderer = ({ node, ...props }) => (
    <a
      {...props}
      style={{ color: "#F58220" }}
      target="_blank"
      rel="noopener noreferrer"
    />
  );

  return (
    <div className="w-[90%] md:w-[65%] mx-auto mt-[1vw]">
      <p
        className={`text-[#333333] md:font-krubMedium font-krubSemibold md:text-[1.2vw] text-[4.5vw] text-center`}
      >
        {data}
      </p>
      <div className="md:text-[1.2vw] text-[4.5vw] text-[#333333] knowMore_bullet">
        {richData?.data?.rich_description?.split("\n")?.map((line, ind) => (
          <Markdown key={ind} components={{ a: LinkRenderer }}>
            {line}
          </Markdown>
        ))}
      </div>
    </div>
  );
};

Description.propTypes = {
  data: PropTypes.string,
};
export default Description;
